import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal, Container, InputGroup, Input, FormGroup, InputGroupAddon } from 'reactstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Button } from '../Forms';
import CloseIcon from '../../images/close-button-black.png';
import {convertToRupiah} from '../../utils';
import FormFeedback from '../Forms/FormFeedback';
import { hasError } from '../../utils/Helpers';
import TopUpBalance from '../PageOffer/TopUpBalance';
import { OFFER_DEDUCT } from '../../config';

const ModalTermsOffer = props => {
  const offerDeduct = convertToRupiah((parseFloat(OFFER_DEDUCT)));
  return (
    <Modal
      toggle={props.onToggle}
      modalClassName="modal-offer-wrapper"
      isOpen={props.isOpen}
    >
      <div className="close-modal" 
      style={{textAlign: 'right'}} 
      onClick={props.onToggle}
      >
        <KickImage src={CloseIcon} alt="close"/>
      </div>
      <Container className="offer-content">
      { 
        props.preventKickCredit?
        <div className="prevent-kickcredit">
          <p>1. You must have the full offer amount in available in your Kick Credit balance.</p>
            {/* <Link to="/user_dashboard/profile-settings"><p style={{textDecoration: 'underline', color: '#4990e2', cursor: 'pointer'}}>TOP UP BALANCE</p></Link> */}
            <TopUpBalance/>
          <p>2. Your kick credit will be deducted IDR. {offerDeduct},- which will be held as a DEPOSIT. This will be returned to you if your offer is accepted and you complete payment.</p>
          <p>3. If your offer is accepted and you do NOT complete payment, the DEPOSIT will not be returned and is claimed by our company. </p>
          <p>4. Only make offers with genuine intent to purchase. Failure to pay will flag your offer as a "hit and run" on our systems and your account may be suspended.</p>
          <p>5. You cannot make an offer that is higher than the listed price.</p>
          <p>6. Offer expires in 30 days. Maintain your offer list on your profile dashboard. </p>
        </div> 
        : 
        <div>
          <div className="offer-content-top terms">
            <p>Make offers according to your budget directly to the sellers listing the particular sneakers. Offers must be a multiple of IDR. 50.000,-</p>
            <p>Your offer will be broadcasted to the sellers, the sellers can either ACCEPT or ADJUST the price.</p>
          </div>
          <div className="offer-content-top terms">
            <p>You will be obligated to complete the transaction once your offer gets accepted. You can complete the payment process via:</p>

            <span>1. Bank Transfer</span>
            <p className="text-italic">Kick Credit will be deducted by IDR. {offerDeduct},- and be taken in as a DEPOSIT and will be returned once you complete the payment process.</p>

            <span>2. Credit Card</span>
            <p className="text-italic">We will authorise your offer amount to your credit card issuer. Should the offer gets rejected, or the transaction process fails, a full refund will be processed.</p>

            <span>3. Kick Credit</span>
            <p className="text-italic">Sufficient amount will be required when making an offer using Kick Credit which will be reserved during the active offer period.</p>
          </div>
        </div>
      }
      </Container>
    </Modal>
  )
}

export default ModalTermsOffer;